import { render, staticRenderFns } from "./CreateProjectWarningDialog.vue?vue&type=template&id=f6d48030&scoped=true&"
import script from "./CreateProjectWarningDialog.vue?vue&type=script&lang=js&"
export * from "./CreateProjectWarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectWarningDialog.vue?vue&type=style&index=0&id=f6d48030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d48030",
  null
  
)

export default component.exports